import { useRef as commonUseRef } from "packages/react";

export const useRef = commonUseRef;
